import React from 'react';
import { styled, DateTimePicker, SubTitle, Body } from '@teko/ds-desktop';
import { t } from '../../i18n.es.js';

const TimeSlotSelect = styled.div`
  display: flex;
  flex-flow: wrap;
  margin: 0 -0.25rem;
  padding-bottom: 0.25rem;

  > * {
    margin: 0 0.25rem 0.5rem;
  }
`;
const TimeSlotOptionDiv = styled.div(({
  theme,
  highlighted
}) => `
  min-width: 5.75rem;
  padding: 0.625rem 0.375rem;
  border: 1px solid ${highlighted ? theme.colors.primary500 : theme.colors.disable};
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  text-align: center;
`);
const TimeSlotOption = ({
  from,
  to,
  highlighted = false,
  onClick = () => {
  }
}) => {
  return /* @__PURE__ */ React.createElement(TimeSlotOptionDiv, {
    highlighted,
    onClick
  }, /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    color: highlighted ? "primary500" : "textPrimary"
  }, `${from} - ${to}`));
};
const StyledDatetimePicker = styled(DateTimePicker)`
  margin-bottom: 0.75rem;
  width: 12rem;

  input {
    background-color: transparent;
  }
`;
const DeliveryDatetimePicker = ({
  selectedTimeSlot,
  timeSlots = [],
  hideTitle = false,
  selectedDate,
  enableDates,
  onChange = () => {
  }
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !hideTitle && /* @__PURE__ */ React.createElement(SubTitle, {
    level: 4
  }, t("Ch\u1ECDn ng\xE0y nh\u1EADn h\xE0ng")), /* @__PURE__ */ React.createElement(StyledDatetimePicker, {
    id: "selected-date-picker",
    value: selectedDate,
    onChange: (val) => {
      onChange(val, selectedTimeSlot);
    },
    disabledDate: (date) => !(enableDates == null ? void 0 : enableDates.some((val) => date.getDate() === val.getDate() && date.getMonth() === val.getMonth() && date.getFullYear() === val.getFullYear()))
  }), !!(timeSlots == null ? void 0 : timeSlots.length) && /* @__PURE__ */ React.createElement(React.Fragment, null, !hideTitle && /* @__PURE__ */ React.createElement(SubTitle, {
    level: 4
  }, t("Ch\u1ECDn khung gi\u1EDD")), /* @__PURE__ */ React.createElement(TimeSlotSelect, {
    id: "selected-time-picker"
  }, timeSlots.map((timeSlot, i) => {
    const highlight = (timeSlot == null ? void 0 : timeSlot.from) === (selectedTimeSlot == null ? void 0 : selectedTimeSlot.from) && (timeSlot == null ? void 0 : timeSlot.to) === (selectedTimeSlot == null ? void 0 : selectedTimeSlot.to);
    return /* @__PURE__ */ React.createElement(TimeSlotOption, {
      key: i,
      from: timeSlot.from,
      to: timeSlot.to,
      highlighted: highlight,
      onClick: () => {
        onChange(selectedDate, highlight ? {
          from: null,
          to: null
        } : timeSlot);
      }
    });
  }))));
};

export { DeliveryDatetimePicker };
